import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { Timeline, DatePicker, Empty, Spin, Pagination } from "antd";
import styled from "styled-components";
import { getUserVisits } from "../../../redux/actions";
import { IoWalkOutline } from "react-icons/io5";

const { RangePicker } = DatePicker;

const TimelineContainer = styled.div`
  padding: 24px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 20px;
  font-family: 'Outfit', sans-serif;

  .filter-section {
    margin-bottom: 32px;
    display: flex;
    justify-content: flex-end;

    .ant-picker {
      background: #fff;
      border: 2px solid #000;
      border-radius: 8px;
      padding: 8px 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      
      .ant-picker-input > input {
        color: #000 !important;
        font-weight: 500;
      }
      
      .ant-picker-range-separator {
        color: #000;
      }
      
      .ant-picker-suffix {
        color: #000;
      }

      &:hover {
        border-color: #333;
      }
    }
  }

  .ant-timeline-item-tail {
    border-left: 2px solid rgba(0, 0, 0, 0.2);
  }

  .ant-timeline-item-head {
    background: transparent;
  }

  .timeline-content {
    background: rgba(255, 255, 255, 0.03);
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba(255, 255, 255, 0.07);
      transform: translateX(5px);
      border-color: rgba(0, 0, 0, 0.3);
    }

    h4 {
      margin: 0;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }

    p {
      margin: 4px 0 0;
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
    }
    
    .date-badge {
      display: inline-block;
      padding: 6px 14px;
      border-radius: 20px;
      background: rgba(0, 0, 0, 0.8);
      color: #eee;
      font-size: 12px;
      font-weight: 500;
      margin-top: 10px;
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  .pagination-container {
    margin-top: 32px;
    display: flex;
    justify-content: center;
  }
`;

const VisitsTimeline = ({ userId }) => {
  const [visitsData, setVisitsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([]);

  const fetchVisits = useCallback((query = "") => {
    setLoading(true);
    getUserVisits(userId, query).then((res) => {
      setVisitsData(res);
      setLoading(false);
    });
  }, [userId]);

  useEffect(() => {
    if (userId) {
      let query = "";
      if (dateRange && dateRange.length === 2) {
        query = `?from=${dateRange[0].format("YYYY-MM-DD")}&to=${dateRange[1].format("YYYY-MM-DD")}`;
      }
      fetchVisits(query);
    }
  }, [userId, dateRange, fetchVisits]);

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  return (
    <TimelineContainer>
      <div className="filter-section">
        <RangePicker 
          onChange={handleDateChange} 
          style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }}
        />
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      ) : visitsData?.data?.length > 0 ? (
        <>
          <Timeline mode="left">
            {visitsData.data.map((visit) => (
              <Timeline.Item 
                key={visit.id} 
                dot={<IoWalkOutline style={{ fontSize: '20px', color: '#000' }} />}
              >
                <div className="timeline-content">
                  <h4>Check-in Recorded</h4>
                  <p>Gym Access Granted</p>
                  <span className="date-badge">
                    {moment(visit.created_at).format("MMMM Do YYYY")} at {visit.in_time ? moment(visit.in_time, "HH:mm:ss").format("h:mm:ss a") : "N/A"}
                  </span>
                </div>
              </Timeline.Item>
            ))}
          </Timeline>
          <div className="pagination-container">
            <Pagination
              current={visitsData?.current_page}
              total={visitsData?.total}
              pageSize={visitsData?.per_page}
              onChange={(page) => {
                let query = `?page=${page}`;
                if (dateRange && dateRange.length === 2) {
                  query += `&from=${dateRange[0].format("YYYY-MM-DD")}&to=${dateRange[1].format("YYYY-MM-DD")}`;
                }
                fetchVisits(query);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ) : (
        <Empty description="No visits found for the selected period" />
      )}
    </TimelineContainer>
  );
};

export default VisitsTimeline;
